<template>
    <transition name="fade">
      <div
        v-if="visible"
        class="fixed"
      >
        <div class="bg-white popup">
          <h2 class="title">{{ title }}</h2>
          <p class="message" style="white-space: pre-line">{{ message }}</p>
          
          <div class="button-group">
            <button @click="cancelPopup" class="secondary_button">{{ cancelButton }}</button>
            <button @click="acceptPopup" class="main_button">{{ acceptButton }}</button>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script setup>
  import { ref, watch, defineProps, defineEmits } from 'vue';
  
  // Define las props del componente para recibir el mensaje de error
  const props = defineProps({
    title: String,
    message: String,
    acceptButton: String,
    cancelButton: String,
  });

  const emit = defineEmits(['acceptCallback', 'cancelCallback']);

  const visible = ref(false);
  
  // Hacer visible el popup cuando haya un mensaje de error
  watch(() => props.title, (newVal) => {
    visible.value = !!newVal;
  });
  
  const acceptPopup = () => {
    visible.value = false;
    emit('acceptCallback');
  };

  const cancelPopup = () => {
    visible.value = false;
    emit('cancelCallback');
  };
</script>
  
  <style scoped>
  /* Estilo de transición para suavizar la aparición/desaparición del popup */
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
  }
  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
  
  /* Fondo translúcido detrás del popup */
  .fixed {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  
  /* Estilo de la caja que contiene el error */
  .bg-white {
    background-color: white;
    padding: 30px;
    border-radius: var(--radius-lg);
    box-shadow: var(--shadow-lg);
    width: 90%;
    max-width: 500px;
    text-align: center;
  }

  .title {
    margin-bottom: var(--spacing-md);
    color: var(--text-color-dark);
  }

  .message {
    color: var(--text-color-dark);
    margin-bottom: var(--spacing-lg);
    line-height: 1.6;
  }

  .button-group {
    display: flex;
    gap: var(--spacing-md);
    margin-top: var(--spacing-lg);
  }

  .button-group button {
    flex: 1;
  }

  @media (max-width: 768px) {
    .bg-white {
      width: 95%;
      padding: 20px;
    }

    .button-group {
      flex-direction: column;
    }
  }
  </style>
  